/*************************************************************************************

    Table of Contents:

    import packages
    import components

    Terms

  *************************************************************************************/

/* import packages */
import React from 'react'

/* import components */
import { TermsText } from '../../components/molecules/Terms'

function Terms(): any {
  return <TermsText p={10} />
}

export default Terms
